var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32175 3.34765H11.6789V1.85025C11.6789 1.35424 12.077 0.951813 12.5718 0.951813C13.0665 0.951813 13.4646 1.35424 13.4646 1.85025V3.34765H14.9527C16.266 3.34765 17.3337 4.42016 17.3337 5.74348V17.7226C17.3337 19.0441 16.266 20.1185 14.9527 20.1185H3.04794C1.73284 20.1185 0.666992 19.0441 0.666992 17.7226V5.74348C0.666992 4.42016 1.73284 3.34765 3.04794 3.34765H4.53604V1.85025C4.53604 1.35424 4.93411 0.951813 5.4289 0.951813C5.92369 0.951813 6.32175 1.35424 6.32175 1.85025V3.34765ZM2.45271 17.7226C2.45271 18.0521 2.71908 18.3216 3.04794 18.3216H14.9527C15.2801 18.3216 15.5479 18.0521 15.5479 17.7226V8.13931H2.45271V17.7226Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_6234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 19.1667,
    fill: "white",
    transform: "translate(0.666992 0.951813)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventModel);
export default __webpack_public_path__ + "static/media/event-model.2270258036d709493284655730d2e040.svg";
export { ForwardRef as ReactComponent };